import { Component } from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router, RouterLink} from '@angular/router';

import {ToastrService} from 'ngx-toastr';
import {TranslocoPipe} from '@jsverse/transloco';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {UserRoles} from '../../entities/user/user.entity';
import {LanguageService} from '../../services/language/language.service';
import {UserService} from '../../services/user/user.service';
import {AuthLayoutComponent} from '../../components/auth-layout/auth-layout.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [
    ReactiveFormsModule,
    RouterLink,
    TranslocoPipe,
    AuthLayoutComponent
],
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  public loginForm: FormGroup;
  public loading = false;
  public errorMessage: string | null = null;

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly toastr: ToastrService,
    private readonly authenticationService: AuthenticationService,
    private readonly languageService: LanguageService,
    private readonly userService: UserService,
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  public async login() {
    this.errorMessage = null;

    if (this.loginForm.invalid) {
      this.errorMessage = 'Please enter valid credentials';
      return;
    }

    this.loading = true;

    const { email, password } = this.loginForm.value;
    this.authenticationService.login(
      email,
      password
    ).subscribe(
      (success) => {
        if (success) {
          const preferredLanguage = this.languageService.getPersistedPreferredLanguage();
          if (preferredLanguage) {
            this.userService.updatePreferredLanguage(preferredLanguage).subscribe({
              next: () => this.languageService.clearPersistedPreferredLanguage(),
            });
          }

          const user = this.authenticationService.getCurrentUser();
          if (user?.roles.includes(UserRoles.photographer)) {
            this.router.navigate(['/manage/dashboard']);
            this.loading = false;
          } else {
            this.router.navigate(['/']);
            this.loading = false;
          }
        } else {
          this.toastr.error('Verify your credentials and try again', 'Login failed');
          this.loading = false;
        }
      }
    )
  }
}
